import { defineComponent as _defineComponent } from 'vue';
import { ComboboxRoot } from 'reka-ui';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'ComboboxRoot',
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get ComboboxRoot() { return ComboboxRoot; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
